import React from "react";
import AppConfig from "../../config/app.config";
import UserService from "../../services/user/user.service";
import { NotificationManager } from "react-notifications";
import { Backdrop, CircularProgress } from "@mui/material";
import AppFooterWeb from "../../components/AppFooterWeb";

export class Artists extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: 1,
      artistList: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getArtistList();
  }

  getArtistList = async () => {
    try {
      const res = await UserService.getArtistList(
        AppConfig.API.SUBSCRIPTION_ID,
        AppConfig.API.VERTICAL_ID
      );
      if (res.error != null) {
        if (res.error?.response?.data?.message != null) {
          NotificationManager.error("", res.error.response.data.message, 3000);
        } else {
          NotificationManager.error("", "Could not get Artist List.", 3000);
        }
        this.setState({ isLoading: 0 });
      } else {
        if (res["status"]) {
          const data = res["data"];
          if (data == null) {
            NotificationManager.error("", "Could not get Artist List.", 3000);
          } else {
            this.setState({
              artistList:
                data != null && data.sort
                  ? data.sort((a, b) => {
                      const nameA = a.artistName.toUpperCase();
                      const nameB = b.artistName.toUpperCase();
                      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                    })
                  : data,
              isLoading: 0,
            });
          }
        } else {
          NotificationManager.error("", "Could not get Artist List.", 3000);
          this.setState({ isLoading: 0 });
        }
      }
    } catch (err) {
      this.setState({ isLoading: 0 });
    }
  };

  render() {
    return (
      <>
        <div className="banner-section">
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          {this.state.artistList != null ? (
            this.state.artistList.length > 0 ? (
              <div className="artists-pagetext">
                <h5>Artists</h5>
                {this.state.artistList.map((artist) => (
                  <div
                    key={artist.artistId}
                    className="artists-page"
                    onClick={() => {
                      this.props.history.push(`artists/${artist.artistId}`);
                    }}
                  >
                    <img
                      src={
                        artist.customerPhoto !== "" &&
                        artist.customerPhoto != null
                          ? artist.customerPhoto
                          : require("../../assets/images/stories-desktop.png")
                      }
                      className="artists-images"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = require("../../assets/images/stories-desktop.png");
                      }}
                      alt="stories"
                    />
                    <p>{artist.artistName}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p>No Artists</p>
            )
          ) : null}
        </div>
        <AppFooterWeb
          pathName={this.props.location?.pathname}
          history={this.props.history}
        />
      </>
    );
  }
}

export default Artists;
